import React from 'react';

const DsraClauseDialogUI = ({ isOpen, onClose, defaultReason }) => {
  if (!defaultReason || !isOpen) return null;

  // Split by ';' so multiple clauses can also be displayed
  const rawClauses = defaultReason.split(';').map(c => c.trim());

  // Convert each clause string into { clausePart, yearMonth }
  const parsedClauses = rawClauses.map(clauseStr => {
    const clausePart = clauseStr.split('|')[0].trim();
    const yearMonthMatch = clauseStr.match(/YearMonth:\s*([A-Za-z]+\s+[0-9]+)/);
    const yearMonth = yearMonthMatch ? yearMonthMatch[1].trim() : 'N/A';

    return { clausePart, yearMonth };
  });

  return (
    <div className="popup" style={{ display: 'flex' }}>
      <div
        className="popup-inner"
        style={{
          maxWidth: '95vw',
          width: '700px',
          overflowX: 'auto',
          paddingBottom: '1rem'
        }}
      >
        <div className="g_flex_h" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
          <h2>DSRA Shortfall Compliance</h2>
          <button
            style={{ border: 'none', background: 'none', fontSize: '24px', cursor: 'pointer' }}
            onClick={onClose}
          >
            &times;
          </button>
        </div>

        <table style={{ marginTop: '1rem', width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ backgroundColor: '#e7e7e7' }}>
              <th style={{ padding: '8px', textAlign: 'left' }}>Compliance</th>
              <th style={{ padding: '8px', textAlign: 'center' }}>YearMonth</th>
            </tr>
          </thead>
          <tbody>
            {parsedClauses.map((item, index) => (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#e7e7e7'
                }}
              >
                <td style={{ padding: '8px', textAlign: 'left' }}>{item.clausePart}</td>
                <td style={{ padding: '8px', textAlign: 'center' }}>{item.yearMonth}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DsraClauseDialogUI;
